/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import { cssMap, jsx } from '@compiled/react';

import EmptyState from '@atlaskit/empty-state';
import type { EmptyStateProps } from '@atlaskit/empty-state/types';
import Image from '@atlaskit/image';
// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- TODO: migrate to @atlaskit/primitives/compiled
import Text from '@atlaskit/primitives/text';

import SearchNoResultsDark from './assets/no-results-dark.svg';
import SearchNoResultsLight from './assets/no-results-light.svg';

const styles = cssMap({
	textWrapper: {
		maxWidth: '235px',
		marginInline: 'auto',
		display: 'inline-block',
	},
});

export type GlobalSideNavigationNoContentProps = {
	description: string;
	elemAfter?: React.ReactNode;
	heading: string;
	renderImage?: EmptyStateProps['renderImage'];
	testId?: string;
};

export function GlobalSideNavigationNoContent({
	testId = 'global-side-navigation--no-content',
	renderImage = () => (
		<Image
			testId="global-side-navigation--no-content-default-image"
			src={SearchNoResultsLight}
			srcDark={SearchNoResultsDark}
			width={96}
			alt=""
		/>
	),
	heading,
	description,
	elemAfter,
}: GlobalSideNavigationNoContentProps): JSX.Element {
	return (
		<EmptyState
			testId={testId}
			renderImage={renderImage}
			header={heading}
			headingLevel={3}
			headingSize="xsmall"
			description={
				<span>
					<span css={styles.textWrapper}>
						<Text size="small" color="color.text.subtle">
							{description}
						</Text>
					</span>
					<span css={styles.textWrapper}>{elemAfter}</span>
				</span>
			}
		/>
	);
}
